// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { linesHeaderStyles } from "@synd/App/Components/Cart/LinesHeader";
import { fontConfig } from "@synd/XDL/PreStyle/typography";
import { color, hideElementOnPrint, xScreen } from "@synd/XDL/Utilities";
import { css } from "styled-components";

linesHeaderStyles.wrapper = {
    css: css`
        display: grid;
        grid-template-columns:
            96px minmax(120px, 1fr) minmax(0, 100px) minmax(0, 172px) minmax(0, 123px) minmax(0, 129px)
            ${({ includeActions }: any) => (includeActions ? css`minmax(0, 120px)` : css`minmax(0, 24px)`)};
        grid-column-gap: 12px;
        grid-auto-flow: column;
        padding: 0 8px;
        color: ${color("common.ui6")};
        font-size: ${fontConfig.xSmallSingleLine.size}px;
        font-weight: ${fontConfig.weight.semiBold};
        width: 100%;
        background: ${color("common.ui8")};
        box-shadow: 0 -1px 1px 0 inset ${color("common.ui4")};

        @media print {
            display: none;
        }
        ${xScreen("lte", "md")} {
            display: none;
        }

        ${hideElementOnPrint}
    `,
};
linesHeaderStyles.itemDescription = {
    css: css`
        grid-column: 1 /3;
        padding: 4px 4px 4px 0;
        ${xScreen("lte", "md")} {
            grid-column: 1 / 6;
        }
    `,
};

linesHeaderStyles.cases = {
    css: css`
        grid-column: 3 / 4;
        padding: 4px 4px 4px 0;
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};
linesHeaderStyles.priceUnit = {
    css: css`
        grid-column: 4/5;
        padding: 4px 4px 4px 0;
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};
linesHeaderStyles.qty = {
    css: css`
        grid-column: 5/6;
        padding: 4px 4px 4px 0;
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};

linesHeaderStyles.total = {
    css: css`
        grid-column: 6/7;
        padding: 4px 4px 4px 0;
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};

linesHeaderStyles.actions = {
    css: css`
        grid-column: 7/8;
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};

linesHeaderStyles.mdScreenBorder = {
    css: css`
        display: none;
        ${xScreen("lte", "md")} {
            display: block;
            border-bottom: 1px solid ${color("common.border")};
        }
    `,
};
